import { TSobReportsPartnerFlagIcons } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'

export const isTopWW = (value?: TSobReportsPartnerFlagIcons) => {
  if (!value) {
    return false
  }

  return value === 'top-icon'
}
